<template>
    <el-descriptions class="margin-top" :column="3" size="medium" border >
        <el-descriptions-item>
            <template #label>
                <div class="cell-item" style="display: flex;align-items: center;justify-content: center;">
                    <el-icon style="margin-right: 5px;">
                        <Aim />
                    </el-icon>
                    点击统计
                </div>
            </template>
            {{ consultCategoryCount }}
        </el-descriptions-item>
    </el-descriptions>
    <!-- 表格组件 -->
    <div id="button_click_statistics">
        <TableList componentTableId="ButtonClickStatistics" @update-list="updateList" excelName="按钮点击统计"
            :table-data="tableData" :header-data="headerData" :table-height="tableMaxHeight" :loading="loading"
            :loading-text="loadingText" :empty-text="emptyText" @searchFnc="searchFnc" @openContent="openContent"
            @changeTimeStart="changeTimeStart" @changeTimeEnd="changeTimeEnd" @handleSelection="handleSelection"
            @changeCascader="changeCascader" @changeRelevance="changeRelevance">
        </TableList>
    </div>
    <!-- 底部工具 -->
    <Pagination :pagination="pagination" :is-loading="loading" @change-pagination="changePagination"></Pagination>
</template>

<script>
import TableList from "@/components/TableHeaderCom/index.vue";
import Pagination from "components/Pagination.vue";
import { reactive, onMounted, toRefs, ref, toRaw, h } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { GetPageList } from "network/buttonClickStatistics"
export default {
    name: "ButtonClickStatistics",
    props: {
        tableMaxHeight: Number,
    },
    components: {
        TableList,
        Pagination,
    },
    setup() {
        //这里定义一个结构体，用来保存项目信息
        const data = reactive({
            // 表格是否在加载中
            loading: true,
            loadingText: "加载中...",
            emptyText: "暂无数据",
            // 分页
            pagination: {
                currentPage: 1,
                pageSize: 20,
                total: 0,
            },
            //表格数据
            tableData: [],
            //表头数据
            headerData: [
                {
                    label: "勾选框",
                    type: "selection",
                    width: "55",
                    fixed: "left",
                },
                {
                    label: "日期时间",
                    prop: "createTime",
                    width: "600",
                    align: "center",
                    noSetText: "未设置",
                    type: "DateSelect",
                    valueFormat:'YYYY-MM-DD HH:mm:ss',
                    dateAndTime: true,
                    dateType: "datetime",
                    createTimeStart: '',
                    createTimeEnd: '',
                },
                {
                    label: "按钮类型",
                    prop: "typeName",
                    width: "600",
                    align: "center",
                    noSetText: "未设置",
                },
                {
                    label: "点击次数",
                    prop: "clickCount",
                    width: "440",
                    align: "center",
                    noSetText: "未设置",
                },
            ],
            search: {
                StartTime: null,
                EndTime: null,
                Type: null,
                PageIndex: 1,
                PageSize: 20,
            },
            typeList: [
                {
                    key: 0,
                    value: '全部'
                },
                {
                    key: 1,
                    value: '电话'
                },
                {
                    key: 2,
                    value: '咨询'
                }
            ],
            multipleSelection: [], //选中行数据
            consultCategoryCount: 0,
        });

        //挂载后调用函数获取项目数据
        onMounted(() => {
            getData();
            // 类型下拉数据
            data.headerData.map((item) => {
                if (item.prop == "typeName") {
                    item.selectOptions = data.typeList;
                }
            });
        });
        // 获取列表
        const getData = async () => {
            data.loading = true;
            const res = await GetPageList(data.search)
            data.loading = false;
            if (res && res.code == 1) {
                data.pagination.total = res.totalCount;
                data.tableData = res.data;
                if(res.data&&res.data.length>0){
                    data.consultCategoryCount = res.data[0]?.consultCategoryCount
                }else{
                    data.consultCategoryCount = 0
                }
            } else {
                data.loading = false;
                ElMessageBox.alert(res.message, {
                    confirmButtonText: "确定",
                })
            }
        };
        // 更新
        const updateList = async () => {
            getData()
        };
        const changePagination = (val) => {
            data.search.PageIndex = val.currentPage;
            data.search.PageSize = val.pageSize;
            updateList();
        };
        const changeCascader = () => {

        };
        const changeRelevance = () => {

        };
        const handleSelection = () => {

        };
        const searchFnc = (val) => {
            if (val.prop && val.prop == "typeName") {
                data.search.Type = val.value == 0 ? null : val.value;
            }
            if (val.prop && val.prop == "createTime") {
                data.search.StartTime = val.value.start ? val.value.start : null;
                data.search.EndTime = val.value.end ? val.value.end : null;
            }
            data.pagination.currentPage = 1;
            getData();
        };
        const openContent = () => {

        };
        //选择时间开始 筛选
        const changeTimeStart = (val) => {
            data.search.StartTime = val.startTime;
            getData();
        };
        //选择时间结束 筛选
        const changeTimeEnd = (val) => {
            data.search.EndTime = val.endTime;
            getData();
        };
        return {
            //解构Data结构体，让模板可以直接调用Data里面的对象
            ...toRefs(data),
            updateList,
            changePagination,
            changeCascader,
            changeRelevance,
            handleSelection,
            searchFnc,
            openContent,
            changeTimeStart,
            changeTimeEnd,
        };
    }
}
</script>

<style lang="scss" scoped>
/* #button_click_statistics {
    margin-top: 50px;
} */
::v-deep .el-descriptions__body .el-descriptions__table {
    display: inline-block;
    min-width:200px !important;
    max-width: 800px !important;
}
::v-deep .el-descriptions__body .el-descriptions__table.is-bordered .el-descriptions__cell{
    width:150px !important;
    text-align: center;
}
</style>